module.exports = __webpack_public_path__ + "img/male_B_01.76b2874e.png";